export const FETCH_CLICKHOUSE_REQUEST = 'reports/clickHouse/FETCH_CLICKHOUSE_REQUEST';
export const FETCH_CLICKHOUSE_SUCCESS = 'reports/clickHouse/FETCH_CLICKHOUSE_SUCCESS';
export const FETCH_CLICKHOUSE_FAILURE = 'reports/clickHouse/FETCH_CLICKHOUSE_FAILURE';

export const FETCH_SNAPSHOT_DETAILS_REQUEST = 'reports/clickHouse/FETCH_SNAPSHOT_DETAILS_REQUEST';
export const FETCH_SNAPSHOT_DETAILS_SUCCESS = 'reports/clickHouse/FETCH_SNAPSHOT_DETAILS_SUCCESS';
export const FETCH_SNAPSHOT_DETAILS_FAILURE = 'reports/clickHouse/FETCH_SNAPSHOT_DETAILS_FAILURE';

export const FETCH_LIVE_ITEM_SALES_V2_REQUEST = 'reports/clickHouse/FETCH_LIVE_ITEM_SALES_V2_REQUEST';
export const FETCH_LIVE_ITEM_SALES_V2_SUCCESS = 'reports/clickHouse/FETCH_LIVE_ITEM_SALES_V2_SUCCESS';
export const FETCH_LIVE_ITEM_SALES_V2_FAILURE = 'reports/clickHouse/FETCH_LIVE_ITEM_SALES_V2_FAILURE';

export const FETCH_LIVE_BY_CHANNEL_REQUEST = 'reports/clickHouse/FETCH_LIVE_BY_CHANNEL_REQUEST';
export const FETCH_LIVE_BY_CHANNEL_SUCCESS = 'reports/clickHouse/FETCH_LIVE_BY_CHANNEL_SUCCESS';
export const FETCH_LIVE_BY_CHANNEL_FAILURE = 'reports/clickHouse/FETCH_LIVE_BY_CHANNEL_FAILURE';

// Dedicated unfiltered by-channel fetch for the Third-Party Marketplace Performance card
// (SSE-16: must ignore the global sales-channel filter, so no orderSource is ever passed)
export const FETCH_THIRD_PARTY_BY_CHANNEL_REQUEST = 'reports/clickHouse/FETCH_THIRD_PARTY_BY_CHANNEL_REQUEST';
export const FETCH_THIRD_PARTY_BY_CHANNEL_SUCCESS = 'reports/clickHouse/FETCH_THIRD_PARTY_BY_CHANNEL_SUCCESS';
export const FETCH_THIRD_PARTY_BY_CHANNEL_FAILURE = 'reports/clickHouse/FETCH_THIRD_PARTY_BY_CHANNEL_FAILURE';

export const FETCH_LIVE_PAYMENTS_REQUEST = 'reports/clickHouse/FETCH_LIVE_PAYMENTS_REQUEST';
export const FETCH_LIVE_PAYMENTS_SUCCESS = 'reports/clickHouse/FETCH_LIVE_PAYMENTS_SUCCESS';
export const FETCH_LIVE_PAYMENTS_FAILURE = 'reports/clickHouse/FETCH_LIVE_PAYMENTS_FAILURE';

export const FETCH_LIVE_REFUND_SUMMARY_REQUEST = 'reports/clickHouse/FETCH_LIVE_REFUND_SUMMARY_REQUEST';
export const FETCH_LIVE_REFUND_SUMMARY_SUCCESS = 'reports/clickHouse/FETCH_LIVE_REFUND_SUMMARY_SUCCESS';
export const FETCH_LIVE_REFUND_SUMMARY_FAILURE = 'reports/clickHouse/FETCH_LIVE_REFUND_SUMMARY_FAILURE';

export const FETCH_LIVE_REFUND_DETAILS_REQUEST = 'reports/clickHouse/FETCH_LIVE_REFUND_DETAILS_REQUEST';
export const FETCH_LIVE_REFUND_DETAILS_SUCCESS = 'reports/clickHouse/FETCH_LIVE_REFUND_DETAILS_SUCCESS';
export const FETCH_LIVE_REFUND_DETAILS_FAILURE = 'reports/clickHouse/FETCH_LIVE_REFUND_DETAILS_FAILURE';

export const FETCH_LIVE_VOID_SUMMARY_REQUEST = 'reports/clickHouse/FETCH_LIVE_VOID_SUMMARY_REQUEST';
export const FETCH_LIVE_VOID_SUMMARY_SUCCESS = 'reports/clickHouse/FETCH_LIVE_VOID_SUMMARY_SUCCESS';
export const FETCH_LIVE_VOID_SUMMARY_FAILURE = 'reports/clickHouse/FETCH_LIVE_VOID_SUMMARY_FAILURE';

export const FETCH_LIVE_VOID_DETAILS_REQUEST = 'reports/clickHouse/FETCH_LIVE_VOID_DETAILS_REQUEST';
export const FETCH_LIVE_VOID_DETAILS_SUCCESS = 'reports/clickHouse/FETCH_LIVE_VOID_DETAILS_SUCCESS';
export const FETCH_LIVE_VOID_DETAILS_FAILURE = 'reports/clickHouse/FETCH_LIVE_VOID_DETAILS_FAILURE';

export const FETCH_LIVE_HOURLY_SALES_REQUEST = 'reports/clickHouse/FETCH_LIVE_HOURLY_SALES_REQUEST';
export const FETCH_LIVE_HOURLY_SALES_SUCCESS = 'reports/clickHouse/FETCH_LIVE_HOURLY_SALES_SUCCESS';
export const FETCH_LIVE_HOURLY_SALES_FAILURE = 'reports/clickHouse/FETCH_LIVE_HOURLY_SALES_FAILURE';

export const FETCH_HOURLY_SALES_REQUEST = 'reports/clickHouse/FETCH_HOURLY_SALES_REQUEST';
export const FETCH_HOURLY_SALES_SUCCESS = 'reports/clickHouse/FETCH_HOURLY_SALES_SUCCESS';
export const FETCH_HOURLY_SALES_FAILURE = 'reports/clickHouse/FETCH_HOURLY_SALES_FAILURE';

export const FETCH_LIVE_STAFF_PERFORMANCE_REQUEST = 'reports/clickHouse/FETCH_LIVE_STAFF_PERFORMANCE_REQUEST';
export const FETCH_LIVE_STAFF_PERFORMANCE_SUCCESS = 'reports/clickHouse/FETCH_LIVE_STAFF_PERFORMANCE_SUCCESS';
export const FETCH_LIVE_STAFF_PERFORMANCE_FAILURE = 'reports/clickHouse/FETCH_LIVE_STAFF_PERFORMANCE_FAILURE';

export const FETCH_LIVE_STAFF_ACTIVE_CLOCKING_REQUEST = 'reports/clickHouse/FETCH_LIVE_STAFF_ACTIVE_CLOCKING_REQUEST';
export const FETCH_LIVE_STAFF_ACTIVE_CLOCKING_SUCCESS = 'reports/clickHouse/FETCH_LIVE_STAFF_ACTIVE_CLOCKING_SUCCESS';
export const FETCH_LIVE_STAFF_ACTIVE_CLOCKING_FAILURE = 'reports/clickHouse/FETCH_LIVE_STAFF_ACTIVE_CLOCKING_FAILURE';

// Staff Roster — GET /sales/live/v2/staff-active-clocking-v2 (paginated/searchable/sortable, any date range)
export const FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_REQUEST = 'reports/clickHouse/FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_REQUEST';
export const FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_SUCCESS = 'reports/clickHouse/FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_SUCCESS';
export const FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_FAILURE = 'reports/clickHouse/FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_FAILURE';

// Order Log — GET /sales/live/v2/order-log (Today only, server-paginated)
export const FETCH_ORDER_LOG_REQUEST = 'reports/clickHouse/FETCH_ORDER_LOG_REQUEST';
export const FETCH_ORDER_LOG_SUCCESS = 'reports/clickHouse/FETCH_ORDER_LOG_SUCCESS';
export const FETCH_ORDER_LOG_FAILURE = 'reports/clickHouse/FETCH_ORDER_LOG_FAILURE';

// Reusable export (CSV / PDF) for any live report
export const EXPORT_ORDER_LOG_REQUEST = 'reports/clickHouse/EXPORT_ORDER_LOG_REQUEST';
export const EXPORT_ORDER_LOG_SUCCESS = 'reports/clickHouse/EXPORT_ORDER_LOG_SUCCESS';
export const EXPORT_ORDER_LOG_FAILURE = 'reports/clickHouse/EXPORT_ORDER_LOG_FAILURE';
export const EXPORT_ORDER_LOG_RESET = 'reports/clickHouse/EXPORT_ORDER_LOG_RESET';

// Order Detail — GET /sales/live/v2/order-detail
export const FETCH_ORDER_DETAIL_REQUEST = 'reports/clickHouse/FETCH_ORDER_DETAIL_REQUEST';
export const FETCH_ORDER_DETAIL_SUCCESS = 'reports/clickHouse/FETCH_ORDER_DETAIL_SUCCESS';
export const FETCH_ORDER_DETAIL_FAILURE = 'reports/clickHouse/FETCH_ORDER_DETAIL_FAILURE';
export const CLEAR_ORDER_DETAIL = 'reports/clickHouse/CLEAR_ORDER_DETAIL';

// Unpaid Orders summary — GET /sales/live/v2/unpaid-orders (Today only, large-page for stats)
export const FETCH_LIVE_UNPAID_ORDERS_REQUEST = 'reports/clickHouse/FETCH_LIVE_UNPAID_ORDERS_REQUEST';
export const FETCH_LIVE_UNPAID_ORDERS_SUCCESS = 'reports/clickHouse/FETCH_LIVE_UNPAID_ORDERS_SUCCESS';
export const FETCH_LIVE_UNPAID_ORDERS_FAILURE = 'reports/clickHouse/FETCH_LIVE_UNPAID_ORDERS_FAILURE';

// Unpaid Order Log — GET /sales/live/v2/unpaid-orders (Today only, server-paginated table)
export const FETCH_LIVE_UNPAID_LOG_REQUEST = 'reports/clickHouse/FETCH_LIVE_UNPAID_LOG_REQUEST';
export const FETCH_LIVE_UNPAID_LOG_SUCCESS = 'reports/clickHouse/FETCH_LIVE_UNPAID_LOG_SUCCESS';
export const FETCH_LIVE_UNPAID_LOG_FAILURE = 'reports/clickHouse/FETCH_LIVE_UNPAID_LOG_FAILURE';

// Comp Order Log — GET /sales/live/v2/comp-order-log (Today only)
export const FETCH_LIVE_COMP_ORDER_LOG_REQUEST = 'reports/clickHouse/FETCH_LIVE_COMP_ORDER_LOG_REQUEST';
export const FETCH_LIVE_COMP_ORDER_LOG_SUCCESS = 'reports/clickHouse/FETCH_LIVE_COMP_ORDER_LOG_SUCCESS';
export const FETCH_LIVE_COMP_ORDER_LOG_FAILURE = 'reports/clickHouse/FETCH_LIVE_COMP_ORDER_LOG_FAILURE';

// Comp Reasons — GET /sales/live/v2/comp-reasons (Today only)
export const FETCH_LIVE_COMP_REASONS_REQUEST = 'reports/clickHouse/FETCH_LIVE_COMP_REASONS_REQUEST';
export const FETCH_LIVE_COMP_REASONS_SUCCESS = 'reports/clickHouse/FETCH_LIVE_COMP_REASONS_SUCCESS';
export const FETCH_LIVE_COMP_REASONS_FAILURE = 'reports/clickHouse/FETCH_LIVE_COMP_REASONS_FAILURE';

// Comp by Staff — GET /sales/live/v2/comp-by-staff (Today only)
export const FETCH_LIVE_COMP_BY_STAFF_REQUEST = 'reports/clickHouse/FETCH_LIVE_COMP_BY_STAFF_REQUEST';
export const FETCH_LIVE_COMP_BY_STAFF_SUCCESS = 'reports/clickHouse/FETCH_LIVE_COMP_BY_STAFF_SUCCESS';
export const FETCH_LIVE_COMP_BY_STAFF_FAILURE = 'reports/clickHouse/FETCH_LIVE_COMP_BY_STAFF_FAILURE';

// Sales by Category — GET /sales/live/v2/categoy-sales (Today only)
export const FETCH_LIVE_CATEGORY_SALES_REQUEST = 'reports/clickHouse/FETCH_LIVE_CATEGORY_SALES_REQUEST';
export const FETCH_LIVE_CATEGORY_SALES_SUCCESS = 'reports/clickHouse/FETCH_LIVE_CATEGORY_SALES_SUCCESS';
export const FETCH_LIVE_CATEGORY_SALES_FAILURE = 'reports/clickHouse/FETCH_LIVE_CATEGORY_SALES_FAILURE';

// Staff Refunds — GET /sales/live/v2/staff-refunds (Today only)
export const FETCH_LIVE_STAFF_REFUNDS_REQUEST = 'reports/clickHouse/FETCH_LIVE_STAFF_REFUNDS_REQUEST';
export const FETCH_LIVE_STAFF_REFUNDS_SUCCESS = 'reports/clickHouse/FETCH_LIVE_STAFF_REFUNDS_SUCCESS';
export const FETCH_LIVE_STAFF_REFUNDS_FAILURE = 'reports/clickHouse/FETCH_LIVE_STAFF_REFUNDS_FAILURE';

// Snapshot Comparison — GET /sales/live/v2/snapshot-details/comparison (Today only)
export const FETCH_SNAPSHOT_COMPARISON_REQUEST = 'reports/clickHouse/FETCH_SNAPSHOT_COMPARISON_REQUEST';
export const FETCH_SNAPSHOT_COMPARISON_SUCCESS = 'reports/clickHouse/FETCH_SNAPSHOT_COMPARISON_SUCCESS';
export const FETCH_SNAPSHOT_COMPARISON_FAILURE = 'reports/clickHouse/FETCH_SNAPSHOT_COMPARISON_FAILURE';

// Channel Names — GET /sales/live/v2/channel-names (Order Log dropdown)
export const FETCH_CHANNEL_NAMES_REQUEST = 'reports/clickHouse/FETCH_CHANNEL_NAMES_REQUEST';
export const FETCH_CHANNEL_NAMES_SUCCESS = 'reports/clickHouse/FETCH_CHANNEL_NAMES_SUCCESS';
export const FETCH_CHANNEL_NAMES_FAILURE = 'reports/clickHouse/FETCH_CHANNEL_NAMES_FAILURE';

// Outstanding Value — GET /sales/live/v2/outstanding-value (Today only)
export const FETCH_LIVE_OUTSTANDING_VALUE_REQUEST = 'reports/clickHouse/FETCH_LIVE_OUTSTANDING_VALUE_REQUEST';
export const FETCH_LIVE_OUTSTANDING_VALUE_SUCCESS = 'reports/clickHouse/FETCH_LIVE_OUTSTANDING_VALUE_SUCCESS';
export const FETCH_LIVE_OUTSTANDING_VALUE_FAILURE = 'reports/clickHouse/FETCH_LIVE_OUTSTANDING_VALUE_FAILURE';

// Labour Employee Sales (KPI) — GET /sales/live/v2/labour-employee-sales
export const FETCH_LABOUR_EMPLOYEE_SALES_REQUEST = 'reports/clickHouse/FETCH_LABOUR_EMPLOYEE_SALES_REQUEST';
export const FETCH_LABOUR_EMPLOYEE_SALES_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_EMPLOYEE_SALES_SUCCESS';
export const FETCH_LABOUR_EMPLOYEE_SALES_FAILURE = 'reports/clickHouse/FETCH_LABOUR_EMPLOYEE_SALES_FAILURE';

// Labour Tips — GET /sales/live/v2/labour-tips
export const FETCH_LABOUR_TIPS_REQUEST = 'reports/clickHouse/FETCH_LABOUR_TIPS_REQUEST';
export const FETCH_LABOUR_TIPS_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_TIPS_SUCCESS';
export const FETCH_LABOUR_TIPS_FAILURE = 'reports/clickHouse/FETCH_LABOUR_TIPS_FAILURE';

// Labour Voids — GET /sales/live/v2/labour-voids
export const FETCH_LABOUR_VOIDS_REQUEST = 'reports/clickHouse/FETCH_LABOUR_VOIDS_REQUEST';
export const FETCH_LABOUR_VOIDS_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_VOIDS_SUCCESS';
export const FETCH_LABOUR_VOIDS_FAILURE = 'reports/clickHouse/FETCH_LABOUR_VOIDS_FAILURE';

// Labour Working Hours (KPI) — GET /sales/live/v2/labour-working-hours
export const FETCH_LABOUR_WORKING_HOURS_REQUEST = 'reports/clickHouse/FETCH_LABOUR_WORKING_HOURS_REQUEST';
export const FETCH_LABOUR_WORKING_HOURS_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_WORKING_HOURS_SUCCESS';
export const FETCH_LABOUR_WORKING_HOURS_FAILURE = 'reports/clickHouse/FETCH_LABOUR_WORKING_HOURS_FAILURE';

// Labour Staff Performance — GET /sales/live/v2/labour-staff-performance
export const FETCH_LABOUR_STAFF_PERFORMANCE_REQUEST = 'reports/clickHouse/FETCH_LABOUR_STAFF_PERFORMANCE_REQUEST';
export const FETCH_LABOUR_STAFF_PERFORMANCE_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_STAFF_PERFORMANCE_SUCCESS';
export const FETCH_LABOUR_STAFF_PERFORMANCE_FAILURE = 'reports/clickHouse/FETCH_LABOUR_STAFF_PERFORMANCE_FAILURE';

// Labour Working Hours Log — GET /sales/live/v2/labour-working-hours-log
export const FETCH_LABOUR_WORKING_HOURS_LOG_REQUEST = 'reports/clickHouse/FETCH_LABOUR_WORKING_HOURS_LOG_REQUEST';
export const FETCH_LABOUR_WORKING_HOURS_LOG_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_WORKING_HOURS_LOG_SUCCESS';
export const FETCH_LABOUR_WORKING_HOURS_LOG_FAILURE = 'reports/clickHouse/FETCH_LABOUR_WORKING_HOURS_LOG_FAILURE';

// Labour KPI Comparison — GET /sales/live/v2/labour-kpi-comparison
export const FETCH_LABOUR_KPI_COMPARISON_REQUEST = 'reports/clickHouse/FETCH_LABOUR_KPI_COMPARISON_REQUEST';
export const FETCH_LABOUR_KPI_COMPARISON_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_KPI_COMPARISON_SUCCESS';
export const FETCH_LABOUR_KPI_COMPARISON_FAILURE = 'reports/clickHouse/FETCH_LABOUR_KPI_COMPARISON_FAILURE';

// Labour Employees — GET /sales/labour/employees
export const FETCH_LABOUR_EMPLOYEES_REQUEST = 'reports/clickHouse/FETCH_LABOUR_EMPLOYEES_REQUEST';
export const FETCH_LABOUR_EMPLOYEES_SUCCESS = 'reports/clickHouse/FETCH_LABOUR_EMPLOYEES_SUCCESS';
export const FETCH_LABOUR_EMPLOYEES_FAILURE = 'reports/clickHouse/FETCH_LABOUR_EMPLOYEES_FAILURE';

// Sales by Channel — Financial Breakdown (ZAR-1555) — GET /sales/live/v2/sales-by-channel-breakdown
export const FETCH_SALES_BY_CHANNEL_BREAKDOWN_REQUEST = 'reports/clickHouse/FETCH_SALES_BY_CHANNEL_BREAKDOWN_REQUEST';
export const FETCH_SALES_BY_CHANNEL_BREAKDOWN_SUCCESS = 'reports/clickHouse/FETCH_SALES_BY_CHANNEL_BREAKDOWN_SUCCESS';
export const FETCH_SALES_BY_CHANNEL_BREAKDOWN_FAILURE = 'reports/clickHouse/FETCH_SALES_BY_CHANNEL_BREAKDOWN_FAILURE';
